import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import AboutHero from './components/AboutHero';
import CompanyIntroSection from './components/CompanyIntroSection';
import ExpertiseSection from './components/ExpertiseSection';
import ProductCasesSection from './components/ProductCasesSection';
import AboutWhySection from './components/AboutWhySection';
import AboutCtaSection from './components/AboutCtaSection';

export default function AboutPage() {
  useSEO({
    title: '關於康永生技｜GMP 認證保健食品代工製造商',
    description: '康永生技是台灣專業保健食品 ODM/OEM 代工製造商，擁有自設 GMP 認證廠房、研發實驗室及品管檢驗室，服務 250+ 品牌，提供完整代工服務。',
    keywords: '關於康永生技,保健食品代工廠,GMP認證,ODM代工,OEM代工,台灣保健食品製造',
    lang: 'zh-TW',
    canonicalPath: '/about',
  });

  return (
    <Layout>
      <SEOJsonLd
        type="WebPage"
        pageTitle="關於康永生技｜GMP 認證保健食品代工製造商"
        pageDescription="康永生技是台灣專業保健食品 ODM/OEM 代工製造商，擁有自設 GMP 認證廠房及研發實驗室。"
        pageUrl="https://kangyong.com/about"
      />
      <AboutHero />
      <CompanyIntroSection />
      <ExpertiseSection />
      <ProductCasesSection />
      <AboutWhySection />
      <AboutCtaSection />
    </Layout>
  );
}
